import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";
import styles from "./CaptionDialog.css";

export default function CaptionDialog(props) {
  if (!props.showing) {
    return null;
  }
  const hasOnlyOneLanguage = props.textTracks.length < 2;
  const languageButtons = props.textTracks.map((track) => {
    const languageClassnames = classnames(styles.languageButton, {
      [styles.active]: track.srclang === props.textTrackLanguage,
    });

    const handler = () => props.onSetTextTrackLanguage(track.srclang);

    // TODO(a11y): Wire up this menu
    return (
      <div
        aria-haspopup="true"
        className={languageClassnames}
        key={track.srclang}
        onClick={handler}
        onKeyUp={keyboardEventPassthroughHandler(handler)}
        role="button"
        tabIndex={0}
      >
        {hasOnlyOneLanguage ? "ON" : track.srclang}
      </div>
    );
  });

  const offButtonClassnames = classnames(styles.languageButton, {
    [styles.active]: props.textTrackLanguage === "" || !props.textTrackLanguage,
  });

  languageButtons.push(
    <div
      className={offButtonClassnames}
      key="off-btn"
      onClick={() => props.onSetTextTrackLanguage("")}
      onKeyUp={keyboardEventPassthroughHandler(() =>
        props.onSetTextTrackLanguage(""),
      )}
      tabIndex={0}
      role="button"
    >
      OFF
    </div>,
  );

  languageButtons.push(
    <div
      className={`${styles.languageButton} ${styles.settingsButton}`}
      key="settings-btn"
      onClick={() => props.onShowTextTrackCaptionSettings()}
      onKeyUp={keyboardEventPassthroughHandler(
        props.onShowTextTrackCaptionSettings,
      )}
      tabIndex={0}
      role="button"
    />,
  );

  return (
    <div className={styles.root}>
      <div className={styles.title}>Closed Captions</div>
      <div
        className={styles.closeButton}
        onClick={props.onCloseClick}
        onKeyUp={keyboardEventPassthroughHandler(props.onCloseClick)}
        role="button"
        tabIndex={0}
      >
        <span className="icon icon-Close2" />
      </div>
      <div className={styles.languageButtons}>{languageButtons}</div>
    </div>
  );
}

CaptionDialog.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onSetTextTrackLanguage: PropTypes.func.isRequired,
  onShowTextTrackCaptionSettings: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
  textTrackLanguage: PropTypes.string.isRequired,
  textTracks: PropTypes.arrayOf(PropTypes.object).isRequired,
};
